module.exports = __webpack_public_path__ + "img/exit_14.861c4ca8.svg";